@for (video of allVideoSources; track i; let i = $index) {
  <app-video-background
    class="survey-video"
    [class.active]="videoSource === video"
    [class.next]="i > 0 && videoSource !== allVideoSources[i]"
    [source]="video"
    [showLogo]="showLogo"
    [showAnonymous]="showAnonymous"
  >
  </app-video-background>
}

@if (surveyStepSignal() === surveySteps.Survey || surveyStepSignal() === surveySteps.Feedback) {
  <a class="survey-header-back back-button" (click)="goBack()">
    <i class="fa-solid fa-chevron-left"></i>
    <div class="text">{{ 'WebApp.v1.Shared.Buttons.Back' | translate }}</div>
  </a>
}

<div class="content">
  <app-pill class="pill">
    <app-pill-progress-bar
      class="progress-bar"
      [title]="currentMenuItemSignal()?.title ?? ''"
      [titleIcon]="currentMenuItemSignal()?.icon ?? ''"
      [progress]="pillProgress()"
      [hideInsights]="currentMenuItemSignal()?.type !== menuItemType.Who5 && currentMenuItemSignal()?.type !== menuItemType.Body"
      [nextTitle]="nextTitle"
      [nextTitleIcon]="nextTitleIcon"
      [isOnDemand]="isOnDemand"
    ></app-pill-progress-bar>
  </app-pill>
  <div
    class="survey-container"
    [class.who5-survey]="currentMenuItemSignal()?.type === menuItemType.Who5 && surveyStepSignal() === surveySteps.Survey"
    [class.body-survey]="currentMenuItemSignal()?.type === menuItemType.Body && surveyStepSignal() === surveySteps.Survey"
    [class.custom]="currentMenuItemSignal()?.type === menuItemType.Custom"
    [class.feedback]="surveyStepSignal() === surveySteps.Feedback"
  >
    @if (surveyStepSignal() === surveySteps.Survey) {
      @if (currentMenuItemSignal()?.type === menuItemType.Who5) {
        <app-survey-slider
          class="select-option-survey"
          [survey]="survey"
          [answerOptions]="answerOptions"
          (backgroundChange)="onVideoChange($event)"
          (surveyFinished)="survey = $event"
          (progressChange)="pillProgress.set($event)"
        ></app-survey-slider>
      } @else if (currentMenuItemSignal()?.type === menuItemType.Body) {
        <app-survey-body
          class="select-option-survey"
          [bodyPrefill]="bodyPrefill"
          [surveySession]="surveySession"
          [isOnDemand]="isOnDemand"
          (bodySurveyFinished)="onBodySurveyFinished($event)"
        ></app-survey-body>
      } @else if (currentMenuItemSignal()?.type === menuItemType.Custom) {
        <app-survey-custom
          class="custom-survey"
          [surveySession]="surveySession"
          [surveyTitle]="currentMenuItemSignal()?.title ?? ''"
          (surveyFinished)="onCustomSurveyFinished($event)"
          (progressChange)="pillProgress.set($event)"
        ></app-survey-custom>
      }
    } @else if (surveyStepSignal() === surveySteps.Feedback || (surveyStepSignal() === surveySteps.Survey && currentMenuItemSignal()?.type === menuItemType.Comment)) {
      <app-survey-feedback
        class="feedback-survey"
        [recipients]="recipients"
        [account]="accountData"
        [disabled]="disabled || !surveySession"
        (feedbackSurveyFinished)="onFeedbackSubmit($event)"
        (skipFeedback)="currentMenuItemSignal()?.type === menuItemType.Who5 ? onSkipToIntervention() : onEmptyFeedbackSubmit()"
      ></app-survey-feedback>
    } @else if (surveyStepSignal() === surveySteps.Done) {
      <div class="done-survey">
        <div class="circle">
          <i class="fa fa-check"></i>
        </div>
        <h1 class="title">{{ 'WebApp.v1.Survey.SurveyDone.Title' | translate }}</h1>
        <p class="description">{{ 'WebApp.v1.Survey.SurveyDone.Description' | translate: { companyName: accountData.companyName, surveyName: currentMenuItemSignal()?.title } }}</p>
      </div>
    } @else if (surveyStepSignal() === surveySteps.Error) {
      <div class="done-survey error">
        <div class="circle error">
          <i class="fa fa-xmark"></i>
        </div>
        <p class="description">{{ 'WebApp.v1.Survey.Error.Description' | translate }}</p>
        <app-button
          class="button"
          [label]="'WebApp.v1.Shared.Buttons.Menu' | translate"
          backgroundColor="transparent"
          (click)="goToMenu()"
        ></app-button>
      </div>
    }
  </div>

  @if (surveyStepSignal() === surveySteps.Feedback) {
    <div class="button-container skip">
      <div
        class="skip"
        [class.disabled]="!surveySession || disabled"
        (click)="currentMenuItemSignal()?.type === menuItemType.Who5 ? onSkipToIntervention() : onEmptyFeedbackSubmit()">
        {{ 'WebApp.v1.Survey.SkipStep' | translate }}
        <i class="fa fa-chevron-right fa-xl"></i>
      </div>
    </div>
  } @else if (surveyStepSignal() === surveySteps.Survey && currentMenuItemSignal()?.type === menuItemType.Who5) {
    <div class="button-container" [class.hidden]="survey.questions[4].answer === -1">
      <div
        class="next"
        [class.disabled]="disabled"
        [class.pulse-text]="!disabled"
        (click)="onWho5SurveyFinished()"
      >
        {{ 'WebApp.v1.Shared.Buttons.Next' | translate }}
        <i class="fa fa-chevron-right fa-xl"></i>
      </div>
    </div>
  }
</div>
